<template>
  <router-link :to="path" @click.native="handleClick" class="menu-item">
    <div class="menu-link">
      {{ text }}
    </div>
    <p class="menu-caption">
      {{ caption }}
    </p>
  </router-link>
</template>

<script>
export default {
  name: 'menu-item',
  props: {
    path: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      required: true,
    },
    caption: {
      type: String,
    },
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
  },
}
</script>

<style scoped lang="scss">
.menu-item {
  display: block;
  padding: $padding-m;
  margin: $margin-xs 0;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  &:active {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
.menu-link {
  display: inline-block;
  color: #002560;
  font-size: $header-size-5;
  margin-bottom: $margin-xs;
  border-bottom: 2px solid #002560;
  font-size: 16px;
  font-weight: 500;
}
.menu-caption {
  color: #777e85;
  font-size: 12px;
  max-width: 300px;
}
</style>
